/**
 * Utility function: Used to calculate scroll direction based on current and previous scrollTop values
 * @param {number} previousScrollPosition - Used to supply previous scroll position
 * @param {number} pageBottomThreshold - Used to supply an offset from the bottom of page - default: 1
 * @returns {object} scrollDirection - Contains the last scroll position and its logged direction of scroll
 */
export const scrollDirection = ({previousScrollPosition, offset, pageBottomThreshold} = {}) => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop,
        offsetDetection = offset || 0,
        lastScrollPosition = previousScrollPosition || window?.scrollDirection?.lastScrollPosition || 0,
        direction,
        scrollDirection,
        threshold = pageBottomThreshold || 1;

    if(!(Math.abs(lastScrollPosition - scrollTop) >= offsetDetection)) return

    if(scrollTop > lastScrollPosition || scrollTop === 0) {
        direction = 'down'

        // automatically force up if bottom of page reached
        if((window.scrollY + window.innerHeight + threshold) > document.body.scrollHeight) {
            direction = 'up'
        }
    } else {
        direction = 'up'
    }

    lastScrollPosition = scrollTop <= 0 ? 0 : scrollTop;

    scrollDirection = {
        direction: direction,
        lastScrollPosition: lastScrollPosition,
    }

    return scrollDirection
}
